if (!customElements.get('m-media-carousel')) {
  class MMediaCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let autoplay;
      if (this.dataset.autoplay) {
        autoplay = this.dataset.autoplay === 'true';
      }

      this.container = this.closest('.m-media-carousel');
      if (!this.container) {
        return;
      }

      this.sliderContainer = this.querySelector('.swiper-container');
      if (!this.sliderContainer) {
        this.classList.add('opacity-100');
        return;
      }

      this.defaultSettings = {
        pagination: {
          el: this.container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.container.querySelector('.m-slider-controls__button-next'),
          prevEl: this.container.querySelector('.m-slider-controls__button-prev'),
        },
        autoplay: autoplay
          ? {
              delay: 5000,
              pauseOnMouseEnter: true,
            }
          : false,
        loop: true,
        slidesPerView: 1,
      };

      this.slidesPerViewDesktop = Number(this.dataset.slidesPerView || 3);
      if (!Number.isFinite(this.slidesPerViewDesktop) || this.slidesPerViewDesktop < 1) {
        this.slidesPerViewDesktop = 3;
      }

      const slidesPerViewTablet = Math.min(this.slidesPerViewDesktop, 2);

      this.settings = {
        centeredSlides: true,
        initialSlide: 0,
        slidesPerView: 1.2,
        spaceBetween: 40,
        watchSlidesProgress: true,
        speed: 500,
        slideToClickedSlide: true,
        loop: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          640: {
            slidesPerView: slidesPerViewTablet,
            spaceBetween: 40,
          },
          992: {
            slidesPerView: this.slidesPerViewDesktop,
            spaceBetween: 40,
          },
        },
      };

      this.initSlider();
      this.initPlayButtons();
    }

    initSlider() {
      if (!window.MinimogLibs || !MinimogLibs.Swiper) {
        setTimeout(() => this.initSlider(), 100);
        return;
      }

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        ...this.defaultSettings,
        ...this.settings,
        on: {
          init: (swiper) => {
            swiper.slideToLoop(0, 0, false);
            setTimeout(() => {
              window.dispatchEvent(new Event('resize'));
            }, 100);
          },
          slideChange: () => {
            this.pauseAllVideos();
          },
        },
      });
    }

    initPlayButtons() {
      this.container.querySelectorAll('.m-media-carousel__play-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const media = btn.closest('.m-media-carousel__media');
          if (!media) return;

          // Video file
          const video = media.querySelector('.m-media-carousel__video[data-type="video_file"]');
          if (video) {
            this.playVideoFile(video, btn);
            return;
          }

          // Video URL (YouTube / Vimeo)
          const iframeWrap = media.querySelector('.m-media-carousel__iframe-wrap[data-type="video_url"]');
          if (iframeWrap) {
            this.playVideoUrl(iframeWrap, btn);
            return;
          }
        });
      });
    }

    playVideoFile(video, btn) {
      const poster = video.closest('.m-media-carousel__media').querySelector('.m-media-carousel__poster');

      if (video.paused) {
        this.pauseAllVideos();
        video.play();
        video.classList.add('playing');
        if (poster) poster.style.opacity = '0';
        btn.classList.add('hidden');
      } else {
        video.pause();
        video.classList.remove('playing');
        if (poster) poster.style.opacity = '';
        btn.classList.remove('hidden');
      }
    }

    playVideoUrl(iframeWrap, btn) {
      if (iframeWrap.classList.contains('active')) {
        return;
      }

      const isYt = iframeWrap.dataset.yt === 'true';
      const isVi = iframeWrap.dataset.vi === 'true';
      const ytId = iframeWrap.dataset.ytid;
      const viId = iframeWrap.dataset.viid;
      const poster = iframeWrap.closest('.m-media-carousel__media').querySelector('.m-media-carousel__poster');
      let src = '';

      if (isYt && ytId) {
        src = `https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0&playsinline=1`;
      } else if (isVi && viId) {
        src = `https://player.vimeo.com/video/${viId}?autoplay=1&playsinline=1`;
      }

      if (src) {
        this.pauseAllVideos();

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';

        iframeWrap.innerHTML = '';
        iframeWrap.appendChild(iframe);
        iframeWrap.classList.add('active');

        if (poster) {
          poster.style.display = 'none';
        }
        btn.classList.add('hidden');
      }
    }

    pauseAllVideos() {
      this.container.querySelectorAll('.m-media-carousel__video.playing').forEach((v) => {
        v.pause();
        v.classList.remove('playing');
        const poster = v.closest('.m-media-carousel__media').querySelector('.m-media-carousel__poster');
        const btn = v.closest('.m-media-carousel__media').querySelector('.m-media-carousel__play-btn');
        if (poster) poster.style.opacity = '';
        if (btn) btn.classList.remove('hidden');
      });

      this.container.querySelectorAll('.m-media-carousel__iframe-wrap.active').forEach((wrap) => {
        wrap.classList.remove('active');
        wrap.innerHTML = '';
        const poster = wrap.closest('.m-media-carousel__media').querySelector('.m-media-carousel__poster');
        const btn = wrap.closest('.m-media-carousel__media').querySelector('.m-media-carousel__play-btn');
        if (poster) poster.style.display = '';
        if (btn) btn.classList.remove('hidden');
      });
    }
  }

  customElements.define('m-media-carousel', MMediaCarousel);
}
